import { motion, useScroll } from 'motion/react'
import React from 'react'

interface Props {
  children: React.ReactNode
  className?: string
  distanceToScrollUp?: number
}

export function HideOnScrollDown({ children, distanceToScrollUp = -120, className }: Props) {
  const [show, setShow] = React.useState(true)
  const { scrollY } = useScroll()
  const lastScrollY = React.useRef(0)

  React.useEffect(() => {
    const unsubscribe = scrollY.onChange(latestY => {
      if (latestY > lastScrollY.current) {
        setShow(false)
      } else {
        setShow(true)
      }
      lastScrollY.current = latestY
    })

    return () => unsubscribe()
  }, [scrollY])

  return (
    <motion.nav
      initial={{ y: 0 }}
      animate={{ y: show ? 0 : distanceToScrollUp }}
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      className={className}
    >
      {children}
    </motion.nav>
  )
}
